import React, { useState } from 'react'
import { FileAttachmentList } from '../common/FileAttachment/FileAttachmentList'

const MAX_ATTACHMENT_FILES = 5

export const useFileAttachments = ({ maxFiles = MAX_ATTACHMENT_FILES } = {}) => {
  const [attachments, setAttachments] = useState([])

  const onUploadDocuments = (data) => {
    setAttachments((prev) => [...prev, ...data])
  }

  const onDocumentRemove = (file, index) => {
    const _files = attachments.filter((_, i) => i !== index)
    setAttachments(_files)
  }

  const onAttachmentClear = () => {
    setAttachments([])
  }

  const List = (
    <>
      <FileAttachmentList files={attachments} onRemove={onDocumentRemove} />
    </>
  )

  return {
    attachments,
    setAttachments,
    onUploadDocuments,
    onDocumentRemove,
    onAttachmentClear,
    List,
    isMaxFilesExceeded: attachments.length > maxFiles,
  }
}
